import { JSX } from "react";
import ArrowIcon from "./Components/ArrowIcon";
import InfrastructureHero from "./Components/InfrastructureHero";
import InfrastructureNavCards from "./Components/InfrastructureNavCards";
import InfrastructureSection from "./Components/InfrastructureSection";
import useScrollToHash from "./Components/useScrollToHash";


const strategyCards = [
    { id: "infrastructurefunding", title: "Infrastructure funding challenge or funding gap" },
    { id: "infrastructurepartnerships", title: "Infrastructure partnerships and its desired social value outcomes" },
    { id: "infrastructureFocus", title: "Infrastructure Focus Area Outcomes" },
    { id: "transversalstrategy", title: "Transversal strategy crafting and measurement" },
    { id: "WCGtransversal", title: "WCG transversal infrastructure governance model (IGM)" },
];

type Section = {
    id: string;
    tag: string;
    title: string;
    sideImage?: string;
    variant?: "gray" | "white";
    content: JSX.Element;
};

const sections: Section[] = [
    {
        id: "infrastructurefunding",
        tag: "WCIS 2050",
        title: "Infrastructure funding challenge or funding gap:",
        sideImage: "media/images/wcisdark.png",
        content: (
            <ul>
                <li>Pressured and dwindling public revenues</li>
                <li>User-fee limitations and effects</li>
                <li>Produces the funding gap that requires innovation (BFF)</li>
            </ul>
        ),
    },
    {
        id: "infrastructurepartnerships",
        tag: "WCIS 2050",
        title:
            "Infrastructure partnerships and its desired social value outcomes:",
        variant: "gray",
        content: (
            <ul>
                <li>Economic aspects – local employment, development</li>
                <li>
                    Social aspects – Spatial justice (accessible, safe, wellbeing)
                </li>
                <li>
                    Environmental aspects – Resilience - Reduce CO2 emissions, support
                    Water & biodiversity conservation
                </li>
            </ul>
        ),
    },
    {
        id: "infrastructureFocus",
        tag: "WCIS 2050",
        title: "Infrastructure Focus Area Outcomes:",
        content: (
            <ul>
                <li>
                    Households <ArrowIcon /> human settlements and an increase in access
                    to basic services
                </li>
                <li>
                    Social <ArrowIcon /> access to health, education, sport, art,
                    recreation and wellness infrastructure
                </li>
                <li>
                    Economic <ArrowIcon /> Investment in infrastructure drives growth
                    and economic activity
                </li>
                <li>
                    Mobility <ArrowIcon /> Safe and secure mobility systems and
                    transportation corridors and facilities
                </li>
            </ul>
        ),
    },
    {
        id: "transversalstrategy",
        tag: "WCIS 2050",
        title:
            "Transversal strategy crafting and measurement (5yr strategic plan) linked to annual plans and practice:",
        variant: "gray",
        content: (
            <ul>
                <li>
                    Transversal strategy crafting of 5yr strategic plan coupled to-
                </li>
                <li>
                    Strategy execution via APP, AOP and AR in each one of the 5 yrs
                </li>
            </ul>
        ),
    },
    {
        id: "WCGtransversal",
        tag: "WCIS 2050",
        title: "WCG transversal infrastructure governance model (IGM)",
        content: (
            <ul>
                <li>
                    Steps 1 and 2 <ArrowIcon /> Guidance and Appraisal
                </li>
                <li>
                    Steps 3 and 4 <ArrowIcon /> Review and Selection
                </li>
                <li>
                    Steps 5 to 8 <ArrowIcon /> Implementation and Operations
                </li>
            </ul>
        ),
    },
];

const WesternCapeInfrastructureStrategy = () => {
    useScrollToHash();

    return (
        <section className="western-cape-infrastructure-strategy-page bg-white overflow-auto">

            <InfrastructureHero
                pdf="pdfs/public-pages/2025-04-04-WCIS-2050.pdf"
                logo="media/images/image.png"
                logoAlt="WCIS 2050"
            >
                <InfrastructureNavCards
                    cards={strategyCards}
                    baseUrl="/pages/western-cape-infrastructure-strategy"
                />
            </InfrastructureHero>

            {sections.map((section) => (
                <InfrastructureSection
                    key={section.id}
                    {...section}
                />
            ))}

        </section>
    );
};

export default WesternCapeInfrastructureStrategy;